import { useFormContext } from 'react-hook-form';
import { Modal, Button } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';

import { AddUserPersonalDataForm } from './addUserPersonalDataForm/AddUserPersonalDataForm';
import { AddUserBasicDataForm } from './addUserBasicDataForm/AddUserBasicDataForm';
import { AddUserFormBody, AddUserProps } from './AddUser.types';
import * as Styled from './AddUser.styles';

export const AddUser = ({
  isModalOpen,
  onModalClose,
  onModalOpen,
  onSubmit,
  isLoadingAddUser,
  isCopyType,
}: AddUserProps) => {
  const { formatMessage } = useLocale();

  const messagess = isCopyType
    ? {
        header: formatMessage({ id: AppMessages['users.addUser.copy'] }),
        submit: formatMessage({ id: AppMessages['users.addUser.copy.submit'] }),
      }
    : {
        header: formatMessage({ id: AppMessages['users.addUser'] }),
        submit: undefined,
      };

  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<AddUserFormBody>();

  return (
    <>
      {isCopyType ? (
        <ActionButton type="copy" onClick={onModalOpen} />
      ) : (
        <Button variant="contained" color="primary" onClick={onModalOpen}>
          {formatMessage({ id: AppMessages['users.addUser'] })}
        </Button>
      )}

      <Modal
        header={messagess.header}
        onClose={onModalClose}
        open={isModalOpen}
        type="form"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isLoadingAddUser || !isValid}
        submitButtonText={messagess.submit}
      >
        <Styled.Grid>
          <Styled.SubHeader>{formatMessage({ id: AppMessages['users.addUser.basicData.title'] })}</Styled.SubHeader>

          <AddUserBasicDataForm />

          <Styled.SubHeader>{formatMessage({ id: AppMessages['users.addUser.personalData.title'] })}</Styled.SubHeader>

          <AddUserPersonalDataForm />
        </Styled.Grid>
      </Modal>
    </>
  );
};
